import React from "react";
import { Link } from "gatsby";
import itinerary from "~/images/itineraries.svg";
import guide from "~/images/guide.svg";
import stay from "~/images/hotel.svg";
//import { StaticImage } from "gatsby-plugin-image";
//import newsl from "~/images/newsl.png";
// import minded from "~/images/like-minded.svg";
//import { StaticImage } from "gatsby-plugin-image";
import bicycle from "~/images/bicycle.svg";
import forbes from "~/images/Forbes_logo.svg.png";
// import stars from "~/images/stars-4.5.svg";
// import tustbadge from "~/images/trust-badge.png";
import condenast from "~/images/Conde_Nast_Traveler_logo.svg.png";
import huffpost from "~/images/HuffPost.svg.png";
import facebook from "~/images/footer-facebook.svg";
//import atta from "~/images/ATTA-Member-Badge-Horizontal.png";
//import trust from "~/images/trustpilot.png";
import linkedin from "~/images/footer-linkedin.svg";
import instagram from "~/images/footer-instagram.svg";
import youtube from "~/images/footer-youtube.svg";
import { ChevronUpIcon } from "@heroicons/react/outline";
//import Location from "~/components/location";
import ZohoCampaignFooter from "~/components/ZohoCampaignFooter";

const Footer = () => {
	return (
		<footer className="">
			<hr></hr>
			<section className="">
				{/* Newsletter */}

				{/* <div className="flex flex-col md:flex-row bg-secondary w-auto h-auto p-2 rounded-lg my-20">
					
					<div className="relative md:w-1/2 mb-8">
						<ZohoCampaign />
					</div>
					<div className="md:w-1/2  lg:ml-28 lg:mr-20">
						<StaticImage
							className="rounded-md"
							src="../images/newsl.png"
							alt="private adventures"
							layout="fullWidth"
							//	aspectRatio={0.77}
							imgStyle={{ width: "398px", height: "517px" }}
						/>
					</div>
				</div> */}

				<div className="container px-5 py-24 mx-auto">
					<div className="text-center mb-20">
						<h2 className="mb-4">What Sets Us Apart</h2>
						{/* <p className="font-light leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
							We put customer expectations at the centre of the way we work, building
							them into our products and service, and giving customers confidence in
							Art of Bicycle Trips.
						</p> */}
						<div className="flex mt-6 justify-center">
							<div className="w-16 h-1 rounded-full bg-primary inline-flex"></div>
						</div>
					</div>
					<div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4 md:space-y-0 space-y-6">
						<div className="p-4 md:w-1/2 lg:w-1/4 flex flex-col text-center items-center">
							{/* <div className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-5 flex-shrink-0">
              <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-10 h-10" viewBox="0 0 24 24">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
              </svg>
            </div> */}
							<div className="w-32 h-32 inline-flex items-center justify-center bg-pink-50 rounded-full mb-5">
								<img className="w-16 h-12" src={itinerary} alt="itinerary icon" />
								{/* <StaticImage
									className=""
									width={40}
									height={30}
									src="../images/itineraries.svg"
									alt="itinerary icon"
								/> */}
							</div>
							<div className="flex-grow">
								<h3 className="text-lg font-medium mb-3">Thoughtfully Crafted</h3>
								<p className="leading-relaxed font-light text-sm">
									Each day is crafted with utmost care so that you are well-rested; get a
									drift of local culture and enjoy the curated routes at your own pace.
								</p>
								{/* <a className="mt-3 text-indigo-500 inline-flex items-center">Learn More
                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a> */}
							</div>
						</div>
						<div className="p-4 md:w-1/2 lg:w-1/4 flex flex-col text-center items-center">
							<div className="w-32 h-32 inline-flex items-center justify-center bg-yellow-50 rounded-full mb-5">
								<img className="w-18 h-14" src={stay} alt="guide icon" />
							</div>
							<div className="flex-grow">
								<h3 className="text-lg font-medium mb-3">Handpicked Hotels</h3>
								<p className="leading-relaxed font-light text-sm">
									True to their heritage and character, luxury and boutique hotels that
									reflect local ethos; providing an unforgettable experience.
									{/*  */}
								</p>
							</div>
						</div>
						<div className="p-4 md:w-1/2 lg:w-1/4 flex flex-col text-center items-center">
							<div className="w-32 h-32 inline-flex items-center justify-center bg-green-50 rounded-full mb-5">
								<img className="w-16 h-12" src={guide} alt="like minded icon" />
							</div>
							<div className="flex-grow">
								<h3 className="text-lg font-medium mb-3">Expert Local Guides</h3>
								<p className="leading-relaxed font-light text-sm">
									{/* With avg. group size of about 8 people per trip, we prioritize quality
									of experience above all else. */}
									{/* 98% of our guests would recommend us to a friend & with 95% joining us
									on their 2nd trip, we're surely doing something awesome! */}
									The folks who steer you towards a unique and enriching experience, and
									sometimes truly a life-changing adventure.
								</p>
							</div>
						</div>
						<div className="p-4 md:w-1/2 lg:w-1/4 flex flex-col text-center items-center">
							<div className="w-32 h-32 inline-flex items-center justify-center bg-blue-50 rounded-full mb-5">
								<img className="w-16 h-12" src={bicycle} alt="bicycle icon" />
							</div>
							<div className="flex-grow">
								<h3 className="text-lg font-medium mb-3">Top-quality Gear</h3>
								<p className="leading-relaxed font-light text-sm">
									{/* We allow you to focus 100% on the cycling experience. We provide all
									gear, meals, transportation, professional guides, fees and more! */}
									With our unwavering commitment to quality, you can fully immerse in the
									adventure while we take care of providing top-notch bike.
								</p>
							</div>
						</div>
					</div>
					<div className="text-right mt-14 sm:mt-6">
						<Link to="/what-to-expect/" className=" text-primary">
							Learn more →
						</Link>
						{/* <button className="flex mx-auto mt-16 text-white bg-indigo-500 border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600 rounded text-lg">
						Button
					</button> */}
					</div>
				</div>
			</section>
			<hr></hr>
			<section>
				<div className="my-20">
					<h2 className="text-center">Join 5000+ Cycling Adventurers</h2>
					{/* <p className="text-center my-4 max-w-xl mx-auto">
						Get access to our new trips, guaranteed departures, and adventure
						inspiration from our experts. Opt-out anytime.
					</p> */}
					<p className="text-center my-4 max-w-xl mx-auto">
						Join our newsletter to get inspiration for your next biking adventure.
						Opt-out anytime.
					</p>
					<ZohoCampaignFooter />
				</div>
			</section>

			{/* hero section */}
			{/* <section className="mb-20">
				<div className="relative overflow-hidden bg-white">
					<div className="pb-80 pt-16 sm:pb-40 sm:pt-24 lg:pb-28 lg:pt-20">
						<div className="relative mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8">
							<div className="sm:max-w-lg">
								
								<p className="text-2xl font-semibold capitalize">
									Stay connected for the latest updates
								</p>
								<p className="mt-6">
									<a
										href="https://www.instagram.com/artofbicycleglobal/"
										target="_blank"
										className=" bg-insta py-2 px-4 sm:px-4 rounded-full text-white"
									>
										Follow Us on Instagram
									</a>
								</p>
							</div>

							<div className="my-20">
								
								<div className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl">
									<div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
										<div className="flex items-center space-x-6 lg:space-x-8">
											<div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
												<div className="h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100">
													<StaticImage
														className="h-full w-full object-cover object-center"
														src="../../images/cambodia-bike-tour-6.jpeg"
														alt="cycling adventures"
														loading="lazy"
													/>
												</div>
												<div className="h-64 w-44 overflow-hidden rounded-lg">
													<StaticImage
														className="h-full w-full object-cover object-center"
														src="../../images/vietnam-bike-tour-4.jpeg"
														alt="cycling adventures"
														loading="lazy"
													/>
												</div>
											</div>
											<div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
												

												<div className="h-64 w-44 overflow-hidden rounded-lg">
													<StaticImage
														className="h-full w-full object-cover object-center"
														src="../../images/rajasthan-bike-tour-4.jpg"
														alt="cycling adventures"
														loading="lazy"
													/>
												</div>
												
											</div>
											<div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
												<div className="h-64 w-44 overflow-hidden rounded-lg">
													<StaticImage
														className="h-full w-full object-cover object-center"
														src="../../images/east-hokkaido-cycling-east-coast.jpeg"
														alt="cycling adventures"
														loading="lazy"
													/>
												</div>
												<div className="h-64 w-44 overflow-hidden rounded-lg">
													<StaticImage
														className="h-full w-full object-cover object-center"
														src="../../images/cambodia-kep-cycling2.jpg"
														alt="cycling adventures"
														loading="lazy"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section> */}

			<section className="bg-gradient-to-r from-white to-secondary -mx-6 md:-mx-16">
				{/* trustpilot */}
				{/* <div className="text-center py-8">
					<a
						href="https://www.trustpilot.com/review/artofbicycletrips.com"
						target="_blank"
						rel="noopener noreferrer"
						className="border border-gray-300 p-4 inline-block mx-auto"
					>
						<div className="text-center md:flex md:justify-center">
							<div className="flex flex-row justify-center items-center">
								<p className="text-base md:text-lg font-semibold">Excellent</p>
								<img
									src={stars}
									alt="Trustpilot Logo"
									className="w-24 h-auto md:w-28 md:h-auto ml-4 inline-block"
								/>
							</div>
							<div className="flex flex-row mt-1 md:mt-0 justify-center items-center">
								<p className="text-sm md:text-sm font-normal md:ml-3">4.6 out of 5</p>
								<img
									src={tustbadge}
									alt="Trustpilot Logo"
									className="w-auto h-6 md:w-auto md:h-6 ml-2 inline-block"
								/>
							</div>
						</div>
					</a>
				</div> */}

				{/* as mentioned in */}
				<div className="mx-auto max-w-7xl px-6 lg:px-8 pt-10">
					<p className="text-center text-sm md:text-base font-semibold">
						Featured in
					</p>
					<div className="mx-auto mt-6 grid max-w-lg grid-cols-3 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-3 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-3">
						<a
							href="https://www.forbes.com/sites/jaredranahan/2023/08/31/five-stunning-cycling-routes-to-explore-across-asia/"
							target="_blank"
							className=""
						>
							<img
								className="col-span-2 max-h-6 w-full object-contain lg:col-span-1"
								src={forbes}
								alt="forbes"
								width={158}
								height={48}
							/>
						</a>
						<a
							href="https://www.huffpost.com/entry/worlds-most-beautiful-bike-trails_b_5671555"
							target="_blank"
							className=""
						>
							<img
								className="col-span-2 max-h-6 w-full object-contain lg:col-span-1"
								src={huffpost}
								alt="huffpost"
								width={158}
								height={48}
							/>
						</a>
						<a
							href="https://www.cntraveller.in/story/be-spoke-travel-india-s-top-cycling-routes/"
							target="_blank"
							className=""
						>
							<img
								className="col-span-2 max-h-6 w-full object-contain lg:col-span-1"
								src={condenast}
								alt="condenast"
								width={158}
								height={48}
							/>
						</a>
						{/* <img
							className="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1"
							src="https://tailwindui.com/img/logos/158x48/savvycal-logo-gray-900.svg"
							alt="SavvyCal"
							width={158}
							height={48}
						/>
						<img
							className="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1"
							src="https://tailwindui.com/img/logos/158x48/statamic-logo-gray-900.svg"
							alt="Statamic"
							width={158}
							height={48}
						/> */}
					</div>
				</div>

				{/* <div className="text-center pt-20">
					<p className="text-primary font-extrabold text-4xl md:text-6xl opacity-20">
						OUR MISSION
					</p>
					<p className="text-sm px-20 md:text-lg font-light">
						Enriching the lives of travelers and local communities
					</p>
				</div> */}
				<div className="container px-5 py-24 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
					{/* <div className="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left">
						<Link
							to="/"
							className="flex font-medium items-center md:justify-start justify-center "
						>
							<span className="ml-6 text-xl font-medium hover:text-primary">
								Art of Bicycle Trips
							</span>
						</Link>
						<p className="mt-2 ml-6 text-sm font-light">
							We're on a mission to enrich the life of travellers and local
							communities.
						</p>
						<p className="my-4 mx-2">
							<a
								href="https://www.trustpilot.com/review/artofbicycletrips.com"
								target="_blank"
							>
								<img className="" src={trust} alt="trust icon" />
							</a>
						</p>
					</div> */}
					<div className="flex-grow flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center">
						<div className="lg:w-1/4 md:w-1/2 w-full px-4">
							<h3 className="font-semibold tracking-wider text-sm mb-3">
								DESTINATIONS
							</h3>
							<ul className="list-none mb-10">
								<li className="mb-1">
									<Link
										to="/destinations/albania-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Albania
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/austria-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Austria
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/bhutan-cycling-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Bhutan
									</Link>
								</li>

								<li className="mb-1">
									<Link
										to="/destinations/cambodia-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Cambodia
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/chile-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Chile
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/croatia-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Croatia
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/czech-republic-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Czech Republic
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/france-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										France
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/greece-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Greece
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/hungary-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Hungary
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/india-bicycle-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										India
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/ireland-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Ireland
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/italy-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Italy
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/japan-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Japan
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/jordan-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Jordan
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/laos-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Laos
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/mongolia-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Mongolia
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/montenegro-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Montenegro
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/morocco-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Morocco
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/nepal-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Nepal
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/norway-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Norway
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/philippines-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Philippines
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/poland-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Poland
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/portugal-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Portugal
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/romania-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Romania
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/slovakia-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Slovakia
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/slovenia-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Slovenia
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/sri-lanka-cycling-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Sri Lanka
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/spain-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Spain
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/taiwan-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Taiwan
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/thailand-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Thailand
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/destinations/vietnam-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Vietnam
									</Link>
								</li>
							</ul>
						</div>
						<div className="lg:w-1/4 md:w-1/2 w-full px-4">
							{/* <h3 className="font-semibold  tracking-wider text-sm mb-3">
								ACTIVITIES
							</h3>
							<nav className="list-none mb-10">
								<li>
									<Link
										to="/activities/cycling/?utm_source=footer&utm_medium=activity-link&utm_campaign=cycling"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Cycling
									</Link>
								</li>
								<li>
									<Link
										to="/activities/multisport/?utm_source=footer&utm_medium=activity-link&utm_campaign=multisport"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Multisport
									</Link>
								</li>
							</nav> */}

							<h3 className="font-semibold  tracking-wider text-sm mb-3">
								COLLECTIONS
							</h3>
							<ul className="list-none mb-10">
								<li className="mb-1">
									<Link
										to="/specialities/bike-and-boat-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Bike & Boat Tours
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/specialities/self-guided-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Self-guided Bike Tours
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/specialities/luxury-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Luxury Bike Tours
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/specialities/e-bike-tours-for-seniors"
										className=" hover:text-primary text-sm text-gray-600"
									>
										E-bike Tours for Seniors
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/specialities/road-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Road Bike Tours
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/specialities/gravel-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Gravel Bike Tours
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/specialities/multi-sport-tours/"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Multi-sport Adventures
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/specialities/family"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Family Bike Tours
									</Link>
								</li>

								<li className="mb-1">
									<Link
										to="/private"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Private Trips
									</Link>
								</li>
							</ul>
						</div>
						<div className="lg:w-1/4 md:w-1/2 w-full px-4">
							<h3 className="font-semibold  tracking-wider text-sm mb-3">
								OUR COMPANY
							</h3>
							<ul className="list-none mb-10">
								<li className="mb-1">
									<Link
										to="/about-us/our-company"
										className=" hover:text-primary text-sm text-gray-600"
									>
										About Us
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/about-us/reviews"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Reviews
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/guaranteed-bike-tours"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Guaranteed Trips
									</Link>
								</li>
								{/* <li className="mb-1">
									<Link
										to="/members-only/"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Membership
									</Link>
								</li> */}
								{/* <li>
									<Link
										to="/contact-us/#offices"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Our Offices
									</Link>
								</li> */}
								{/* <li>
									<a
										href="https://www.trustpilot.com/review/artofbicycletrips.com"
										target="_blank"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Guest Reviews
									</a>
								</li> */}
								<li className="mb-1">
									<Link
										to="/what-to-expect"
										className=" hover:text-primary text-sm text-gray-600"
									>
										What to Expect
									</Link>
								</li>
								<li className="mb-1">
									<Link to="/faqs" className=" hover:text-primary text-sm text-gray-600">
										FAQs
									</Link>
								</li>

								<li className="mb-1">
									<Link to="/blog" className=" hover:text-primary text-sm text-gray-600">
										Expert Blog
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/travel-advisors"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Travel Advisors
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/about-us/work-with-us"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Work With Us
									</Link>
								</li>
								{/* <li>
									<Link
										to="/reviews"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Reviews
									</Link>
								</li> */}
								<li className="mb-1">
									<Link
										to="/terms-conditions"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Terms &amp; Conditions
									</Link>
								</li>
								<li className="mb-1">
									<Link
										to="/privacy-policy"
										className=" hover:text-primary text-sm text-gray-600"
									>
										Privacy Policy
									</Link>
								</li>
								{/* <li className="mt-4">
									<img className="w-2/3 h-auto" src={atta} alt="ATTA icon" />
								</li> */}
								{/* <li className="my-6 lg:block">
									<a
										href="https://www.instagram.com/artofbicycleglobal/"
										target="blank"
										className=" bg-insta font-medium py-2 px-4 text-sm sm:px-4 rounded text-white"
									>
										Follow us on Instagram
									</a>
								</li> */}
								{/* <li className="my-6 lg:block">
									<Link
										to="/newsletter-signup/"
										className=" bg-white border border-primary2 font-medium py-2 px-5 text-sm sm:px-6 rounded text-gray-600"
									>
										Newsletter Signup
									</Link>
								</li> */}
							</ul>
						</div>
						<div className="lg:w-1/4 md:w-1/2 w-full px-4">
							<h3 className="font-semibold  tracking-wider text-sm mb-3">
								CONTACT US
							</h3>
							<ul className="list-none mb-10">
								<li className="my-6 lg:block">
									{/* <a
										//id="send_message"
										className="hover:text-primary text-sm text-primary font-semibold uppercase"
										href="mailto:contact@artofbicycletrips.com"
									>
										Send a Message
									</a> */}
									{/* <PopupButton
										id="SKjDwiLC"
										className="bg-primary py-2 px-2 sm:px-4 rounded-full text-white mr-4"
									>
										Send a Message
									</PopupButton> */}

									<Link
										to="/contact-us?utm_source=footer&utm_medium=contact-us&utm_campaign=send-a-message"
										className=" bg-primary uppercase font-semibold tracking-wide py-2 px-5 sm:px-6 rounded-full text-white"
									>
										Send a Message
									</Link>
								</li>
								{/* <li className="mt-10 mb-7">
									<p className=" text-sm text-gray-600 uppercase mb-4 mt-10">
										WhatsApp:
									</p>
									<p className="">
										<a
											href="https://wa.me/917975945272"
											target="_blank"
											rel="noopener noreferrer nofollow"
											className="bg-whatsapp font-medium py-2 px-5 sm:px-6 border border-gray-800 rounded-full text-gray-800"
										>
											WhatsApp Us
										</a>
									</p>
								</li> */}
								{/* <li className="mt-10 mb-7">
									<p className="">
										<a
											href="https://calendly.com/artofbicycletrips/chat-to-our-sales-team"
											target="_blank"
											rel="noopener noreferrer nofollow"
											className=" bg-white py-2 px-2 sm:px-3 border border-border rounded-full text-primary"
										>
											Request a Callback
										</a>
									</p>
								</li> */}
								{/* <li className="my-4">
									<p className=" text-sm text-gray-600 uppercase">email Us:</p>
									<a
										className=" text-gray-900"
										href="mailto:contact@artofbicycletrips.com"
									>
										contact@artofbicycletrips.com
									</a>
								</li> */}
								<li>
									<p className=" text-sm text-gray-600 uppercase mb-4 mt-10">Call Us:</p>
									<p className="mb-4">
										{/* <a href="tel:+1-970-315-2963">
											US/CA: <span className="underline">+1 970 315 2963</span>
										</a> */}
										<a href="tel:+1-707-590-5789">
											US/CA: <span className="underline">+1 707 590 5789</span>
										</a>
									</p>
									<p className="mb-4">
										<a href="tel:+447448517563">
											UK/EU: <span className="underline">+44 74485 17563</span>
										</a>
									</p>
									<p className="mb-1">
										<a href="tel:+918208924403">
											AU/NZ: <span className="underline">+91 8208924403</span>
										</a>
									</p>
									{/* <p className="mb-1">
										<a href="tel:+91-782-948-6953">IN: +91 782 948 6953</a>
									</p> */}
								</li>
								{/* <li className="my-10">
									<Location />
								</li> */}
							</ul>
						</div>
					</div>
				</div>

				<div>
					<div className="flex justify-center space-x-2 ">
						<a
							href="https://www.instagram.com/artofbicycleglobal/"
							target="_blank"
							rel="noopener noreferrer nofollow"
						>
							<img className="" src={instagram} alt="instagram icon" />
						</a>
						<a
							href="https://www.youtube.com/channel/UC10rhc0jnPaJZRd4BwJpT1g"
							target="_blank"
							rel="noopener noreferrer nofollow"
						>
							<img className="" src={youtube} alt="youtube icon" />
						</a>
						<a
							href="https://www.linkedin.com/company/art-of-bicycle-trips"
							target="_blank"
							rel="noopener noreferrer nofollow"
						>
							<img className="" src={linkedin} alt="linkedin icon" />
						</a>
						<a
							href="https://www.facebook.com/artofbicycleglobal"
							target="_blank"
							rel="noopener noreferrer nofollow"
						>
							<img className="" src={facebook} alt="facebook icon" />
						</a>
					</div>
					{/* <div className="py-3 flex flex-col md:flex-row justify-center items-center space-x-1 mb-4 ">
						<p className="text-sm text-gray-500">© 2024 Art of Bicycle Trips</p>
					</div> */}
					{/* <a
							className="text-sm text-gray-500"
							href="mailto:contact@artofbicycletrips.com"
						>
							contact@artofbicycletrips.com
						</a> */}

					<div className="text-center py-4">
						<p className="text-sm text-gray-500">© 2025 Art of Bicycle Trips</p>

						<p className="text-sm text-gray-500 capitalize">
							Active Travels Pte Ltd, 32 Pekin Street #05-01 Singapore (048762)
						</p>
					</div>
					<div className="text-center pb-2">
						<a href="#top" className="text-sm hover:text-primary">
							Go to Top <ChevronUpIcon className="h-4 w-4 text-sm inline-flex ml-2" />
						</a>
					</div>
				</div>
			</section>

			{/* <div className="sticky bottom-0">
				<Link
					to="/contact-us?utm_source=footer&utm_medium=contact-us&utm_campaign=make-an-inquiry"
					className="w-full flex sm:hidden justify-center px-8 py-3 border border-transparent text-base font-medium text-white bg-primary hover:bg-primary md:py-4 md:px-10"
				>
					Make an Inquiry
				</Link>
			</div> */}
		</footer>
	);
};

export default Footer;
